import config from "../app-config";
import serverFetch from "../utils/serverFetch";

export const get_all_relationships = async () => {
    return await serverFetch({
        endpoint: `${config.endpoint}/relationship/list`,
        method: "GET"
    })
}

export const get_relationship_by_id = async (relationship_id) => {
    if (!relationship_id) return { error: "No relationship id provided" }
    return await serverFetch({
        endpoint: `${config.endpoint}/relationship/id/${relationship_id}`,
        method: "GET"
    })
}

export const create_new_relationship = async (relationship_data) => {
    return await serverFetch({
        endpoint: `${config.endpoint}/relationship`,
        method: "POST",
        body: JSON.stringify(relationship_data)
    })
}

export const update_relationship_by_id = async (relationship_id, relationship_data) => {
    if (!relationship_id) return { error: "No relationship id provided" }
    return await serverFetch({
        endpoint: `${config.endpoint}/relationship/id/${relationship_id}`,
        method: "PUT",
        body: JSON.stringify(relationship_data)
    })
}

export const delete_relationship_by_id = async (relationship_id) => {
    if (!relationship_id) return { error: "No relationship id provided" }
    return await serverFetch({
        endpoint: `${config.endpoint}/relationship/id/${relationship_id}`,
        method: "DELETE"
    })
}
